document.querySelectorAll('details.accordion').forEach(d => {
  const plus = d.querySelector('.icon-plus');
  const minus = d.querySelector('.icon-minus');

  if (d.open) {
    plus.classList.add('hidden');
    minus.classList.remove('hidden');
  } else {
    minus.classList.add('hidden');
    plus.classList.remove('hidden');
  }

  d.addEventListener('toggle', () => {
    if (d.open) {
      plus.classList.add('hidden');
      minus.classList.remove('hidden');
    } else {
      minus.classList.add('hidden');
      plus.classList.remove('hidden');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('scroll-carousel.bl-slidable__multi-col.is-scrollable');

  carousels.forEach(carousel => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isMoved = false;

    carousel.querySelectorAll('img, a').forEach(el => {
      el.draggable = false;
    });

    carousel.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      isDown = true;
      isMoved = false;

      // Disable snapping and smoothing for raw tracking
      carousel.style.scrollSnapType = 'none';
      carousel.style.scrollBehavior = 'auto';
      carousel.classList.add('is-dragging');

      startX = e.pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      carousel.classList.remove('is-dragging');

      if (isMoved) {
        // 1. Find the closest item to snap to
        const items = carousel.querySelectorAll('multi-column-item');
        const currentScroll = carousel.scrollLeft;
        let closestOffset = currentScroll;
        let minDiff = Number.MAX_SAFE_INTEGER;

        items.forEach(item => {
          const diff = Math.abs(item.offsetLeft - currentScroll);
          if (diff < minDiff) {
            minDiff = diff;
            closestOffset = item.offsetLeft;
          }
        });

        // 2. Smoothly glide to that specific item
        carousel.style.scrollBehavior = 'smooth';
        carousel.scrollTo({ left: closestOffset });

        // 3. Re-enable snap-type AFTER the glide is roughly finished
        // This prevents the "jump"
        setTimeout(() => {
          carousel.style.scrollSnapType = 'x mandatory';
          carousel.style.scrollBehavior = ''; // Reset to default
          carousel.style.pointerEvents = 'all';
        }, 400); // 400ms matches standard smooth scroll duration
      } else {
        // If they just clicked without moving, just reset
        carousel.style.scrollSnapType = 'x mandatory';
        carousel.style.pointerEvents = 'all';
      }
    };

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mouseleave', endDrag);

    window.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault(); 
      
      const x = e.pageX - carousel.offsetLeft;
      const walk = (x - startX); 

      if (Math.abs(walk) > 5) {
        isMoved = true;
        carousel.style.pointerEvents = 'none';
      }

      carousel.scrollLeft = scrollLeft - walk;
    });

    carousel.addEventListener('click', (e) => {
      if (isMoved) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  });
});
